// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/lock.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  @media (min-width: 768px) {}

  @media (max-width: 768px) {

    .certificate-wrapper {
      left: -22px;
      scale: .8;
    }

    .video-container {
      width: 100vw;
    }

    .video-wrapper {
      width: 100vw;
    }

    .certificate-wrapper img {}
  }

  @media (max-width: 425px) {
    .certificate-wrapper {
      left: -105px;
      scale: .5;
    }



    .video-wrapper {
      margin-bottom: 0px;
    }

    .titles-container {

      margin-top: 20px;
    }

    .video-container video {
      width: 100vw !important;
    }

    .video-wrapper {
      width: 100vw !important;
    }
  }

  .logout-btn {
    position: absolute;
    right: 10px;
    top: 120px;
  }

  .education-page-authenticator {
    padding-bottom: 400px;
    padding-top: 50px;
  }



  .education-page {


    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding-top: 50px;

  }


  .auth-block {
    margin-top: 10rem;

  }



  .video-container {
    padding-top: 60px;
    display: flex;
    flex-wrap: wrap;
    /* gap: 80px; */
    /* justify-content: center; */
    max-width: 800px;
    position: relative;
    z-index: 1;

  }




  .locked {
    filter: grayscale(90%);
    position: relative !important;
    pointer-events: none;
    /* background-image: url('../assets/lock.png') !important; */
    transition: filter 0.6s ease, background-size 0.6s ease;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    z-index: 3 !important;
  }


  .locked::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-size: 50%;
    background-repeat: no-repeat;
    opacity: .9;
    pointer-events: none;
    z-index: 4;
    transition: filter 0.6s ease, background-size 0.6s ease;
  }

  .lock-overlay {
    position: absolute;
    top: 0;
    left: 0;

    width: 300px;
    background: rgba(0, 0, 0, 0);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 12px;
    transition: background-color 0.6s ease;
  }



  .video-container video {
    width: 100%;
    border-radius: 8px 8px 0px 0px;


    /* Ensure relative positioning for overlay within each video */
  }

  

  .titles-container {
    background-color: #ffffff;
    /* Grey background color */
    padding: 20px;
    
    /* Adjust the padding as needed */
    border-radius: 0 0 8px 8px;
    /* Rounded corners for the top */
    box-sizing: border-box;
    width: 100%;
    margin-top: -10px;
    margin-bottom: 80px;
    min-height: 220px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  }

  .video-title {
    font-family: Georgia, 'Times New Roman', Times, serif;
    color: #3b3b3b;
    font-size: 23px;
    margin-bottom: 10px;
    margin-top: 20px;
    text-align: left;
    /* Left-align the title */
    /* Space between title and info */
  }

  .video-info {
    font-family: Georgia, 'Times New Roman', Times, serif;
    color: #3b3b3b;
    font-size: 18px;
    margin: 0;
    text-align: left;
    /* Left-align the title */
    /* Remove default margin for the paragraph */
  }

  .congrats-div input {
    font-family: 'Avenir Light', sans-serif;
    width: 100%;
    margin-bottom: 20px;
    margin-left: 5px;
    margin-right: 5px;
  }

  .certificate-wrapper {
    position: relative;
    align-items: center !important;
    margin-top: 20px;
  }



  .certificate-wrapper-Name {
    position: absolute;
    font-family: 'Poppins', sans-serif;
    white-space: nowrap;
    top: 270px; /* Adjust top position as needed */
    font-size: 38px;
    left: 50%; /* Position at the center horizontally */
    transform: translateX(-50%); /* Center horizontally */
  }

  .birthdate{
    display: flex;
    margin-bottom: 5px;
  }

  .certificate-wrapper-Sport {
    position: absolute;


    left: 480px;
    top: 405px;
    font-size: 25px !important;
  }

  .certificate-wrapper-Date {
    position: absolute;
    left: 200px;
    top: 405px;
    font-size: 25px !important;
  }


  .certificate-wrapper img {
    width: 800px;
    height: auto;
  }

  .select-form-input {
    width: 100%;
    padding: 10px;
    margin-bottom: 10px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    background-color: white;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
  }


  .dwn-btn {
    background-color: #ff3131 !important;
    font-size: 16px !important;
    color: #ffffff;
    font-weight: bold;
    border-radius: 5px;
    border-width: 1px;
    padding: 3px 10px;
    min-width: 200px;
    text-align: center;
    margin: 0px 10px;
  }

  .dwn-btn:hover {
    transition: .2s;
    scale: 1.1 !important;
  }


  .dwn-btn:disabled {
    opacity: 0.5;
    background-color: grey !important;
    transition: 1s;
  }`, "",{"version":3,"sources":["webpack://./src/pages/EducationPages.css"],"names":[],"mappings":"EAAE,2BAA2B;;EAE3B;;IAEE;MACE,WAAW;MACX,SAAS;IACX;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,YAAY;IACd;;IAEA,0BAA0B;EAC5B;;EAEA;IACE;MACE,YAAY;MACZ,SAAS;IACX;;;;IAIA;MACE,kBAAkB;IACpB;;IAEA;;MAEE,gBAAgB;IAClB;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,uBAAuB;IACzB;EACF;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;;;EAIA;;;IAGE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,iBAAiB;;EAEnB;;;EAGA;IACE,iBAAiB;;EAEnB;;;;EAIA;IACE,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;;EAEZ;;;;;EAKA;IACE,sBAAsB;IACtB,6BAA6B;IAC7B,oBAAoB;IACpB,4DAA4D;IAC5D,uDAAuD;IACvD,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;IAC5B,qBAAqB;EACvB;;;EAGA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,yDAA2C;IAC3C,2BAA2B;IAC3B,oBAAoB;IACpB,4BAA4B;IAC5B,WAAW;IACX,oBAAoB;IACpB,UAAU;IACV,uDAAuD;EACzD;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;;IAEP,YAAY;IACZ,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,sCAAsC;EACxC;;;;EAIA;IACE,WAAW;IACX,8BAA8B;;;IAG9B,8DAA8D;EAChE;;;;EAIA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,aAAa;;IAEb,iCAAiC;IACjC,0BAA0B;IAC1B,gCAAgC;IAChC,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,uCAAuC;EACzC;;EAEA;IACE,qDAAqD;IACrD,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,iCAAiC;EACnC;;EAEA;IACE,qDAAqD;IACrD,cAAc;IACd,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,yBAAyB;IACzB,4CAA4C;EAC9C;;EAEA;IACE,uCAAuC;IACvC,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;IAC9B,gBAAgB;EAClB;;;;EAIA;IACE,kBAAkB;IAClB,kCAAkC;IAClC,mBAAmB;IACnB,UAAU,EAAE,kCAAkC;IAC9C,eAAe;IACf,SAAS,EAAE,wCAAwC;IACnD,2BAA2B,EAAE,wBAAwB;EACvD;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;;;IAGlB,WAAW;IACX,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,0BAA0B;EAC5B;;;EAGA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;EACvB;;;EAGA;IACE,oCAAoC;IACpC,0BAA0B;IAC1B,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;;EAGA;IACE,YAAY;IACZ,iCAAiC;IACjC,cAAc;EAChB","sourcesContent":["  @media (min-width: 768px) {}\n\n  @media (max-width: 768px) {\n\n    .certificate-wrapper {\n      left: -22px;\n      scale: .8;\n    }\n\n    .video-container {\n      width: 100vw;\n    }\n\n    .video-wrapper {\n      width: 100vw;\n    }\n\n    .certificate-wrapper img {}\n  }\n\n  @media (max-width: 425px) {\n    .certificate-wrapper {\n      left: -105px;\n      scale: .5;\n    }\n\n\n\n    .video-wrapper {\n      margin-bottom: 0px;\n    }\n\n    .titles-container {\n\n      margin-top: 20px;\n    }\n\n    .video-container video {\n      width: 100vw !important;\n    }\n\n    .video-wrapper {\n      width: 100vw !important;\n    }\n  }\n\n  .logout-btn {\n    position: absolute;\n    right: 10px;\n    top: 120px;\n  }\n\n  .education-page-authenticator {\n    padding-bottom: 400px;\n    padding-top: 50px;\n  }\n\n\n\n  .education-page {\n\n\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding-top: 50px;\n\n  }\n\n\n  .auth-block {\n    margin-top: 10rem;\n\n  }\n\n\n\n  .video-container {\n    padding-top: 60px;\n    display: flex;\n    flex-wrap: wrap;\n    /* gap: 80px; */\n    /* justify-content: center; */\n    max-width: 800px;\n    position: relative;\n    z-index: 1;\n\n  }\n\n\n\n\n  .locked {\n    filter: grayscale(90%);\n    position: relative !important;\n    pointer-events: none;\n    /* background-image: url('../assets/lock.png') !important; */\n    transition: filter 0.6s ease, background-size 0.6s ease;\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    z-index: 3 !important;\n  }\n\n\n  .locked::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-image: url('../assets/lock.png');\n    background-position: center;\n    background-size: 50%;\n    background-repeat: no-repeat;\n    opacity: .9;\n    pointer-events: none;\n    z-index: 4;\n    transition: filter 0.6s ease, background-size 0.6s ease;\n  }\n\n  .lock-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    width: 300px;\n    background: rgba(0, 0, 0, 0);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    font-size: 12px;\n    transition: background-color 0.6s ease;\n  }\n\n\n\n  .video-container video {\n    width: 100%;\n    border-radius: 8px 8px 0px 0px;\n\n\n    /* Ensure relative positioning for overlay within each video */\n  }\n\n  \n\n  .titles-container {\n    background-color: #ffffff;\n    /* Grey background color */\n    padding: 20px;\n    \n    /* Adjust the padding as needed */\n    border-radius: 0 0 8px 8px;\n    /* Rounded corners for the top */\n    box-sizing: border-box;\n    width: 100%;\n    margin-top: -10px;\n    margin-bottom: 80px;\n    min-height: 220px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n  }\n\n  .video-title {\n    font-family: Georgia, 'Times New Roman', Times, serif;\n    color: #3b3b3b;\n    font-size: 23px;\n    margin-bottom: 10px;\n    margin-top: 20px;\n    text-align: left;\n    /* Left-align the title */\n    /* Space between title and info */\n  }\n\n  .video-info {\n    font-family: Georgia, 'Times New Roman', Times, serif;\n    color: #3b3b3b;\n    font-size: 18px;\n    margin: 0;\n    text-align: left;\n    /* Left-align the title */\n    /* Remove default margin for the paragraph */\n  }\n\n  .congrats-div input {\n    font-family: 'Avenir Light', sans-serif;\n    width: 100%;\n    margin-bottom: 20px;\n    margin-left: 5px;\n    margin-right: 5px;\n  }\n\n  .certificate-wrapper {\n    position: relative;\n    align-items: center !important;\n    margin-top: 20px;\n  }\n\n\n\n  .certificate-wrapper-Name {\n    position: absolute;\n    font-family: 'Poppins', sans-serif;\n    white-space: nowrap;\n    top: 270px; /* Adjust top position as needed */\n    font-size: 38px;\n    left: 50%; /* Position at the center horizontally */\n    transform: translateX(-50%); /* Center horizontally */\n  }\n\n  .birthdate{\n    display: flex;\n    margin-bottom: 5px;\n  }\n\n  .certificate-wrapper-Sport {\n    position: absolute;\n\n\n    left: 480px;\n    top: 405px;\n    font-size: 25px !important;\n  }\n\n  .certificate-wrapper-Date {\n    position: absolute;\n    left: 200px;\n    top: 405px;\n    font-size: 25px !important;\n  }\n\n\n  .certificate-wrapper img {\n    width: 800px;\n    height: auto;\n  }\n\n  .select-form-input {\n    width: 100%;\n    padding: 10px;\n    margin-bottom: 10px;\n    box-sizing: border-box;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 16px;\n    background-color: white;\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n  }\n\n\n  .dwn-btn {\n    background-color: #ff3131 !important;\n    font-size: 16px !important;\n    color: #ffffff;\n    font-weight: bold;\n    border-radius: 5px;\n    border-width: 1px;\n    padding: 3px 10px;\n    min-width: 200px;\n    text-align: center;\n    margin: 0px 10px;\n  }\n\n  .dwn-btn:hover {\n    transition: .2s;\n    scale: 1.1 !important;\n  }\n\n\n  .dwn-btn:disabled {\n    opacity: 0.5;\n    background-color: grey !important;\n    transition: 1s;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
